
require('angular').module('clientDashboardApp.chatmeterAdmin', [
  require('./healthmeter/module'),
  require('./billingAccounts/module'),
  require('./yelpSubscription/yelpSubscription.module'),
  require('./listingManagement/listingManagement.module'),
  require('./adviceLocalBackSync/adviceLocalBackSync.module'),
  require('./manageTool/module').moduleName,
]);


